import { FunctionComponent, useEffect, useMemo, useRef, useState } from 'react'
import Layout from './components/Layout'
import RegisterForm from './components/RegisterForm'
import SuccessModal from './components/SuccessModal'
import {
  getAvailabilityCalls,
  getPreferences,
  getSpecialities,
  registerProfessional,
} from '@/services/services'
import {
  SpecialitiesItems,
  PreferencesItems,
  AvailabilityCallsItems,
} from './types'
import { Registry } from '@/entities/Registry'
import { toast } from '@conexasaude/hero-web'
import ReCAPTCHA from 'react-google-recaptcha'
import { UseFormReturnType } from '@mantine/form/lib/use-form'
import { useLocation } from 'react-router-dom'

const Register: FunctionComponent = () => {
  const [specialities, setSpecialities] = useState<SpecialitiesItems>([])
  const [preferences, setPreferences] = useState<PreferencesItems>([])
  const [availabityCalls, setAvailabityCalls] =
    useState<AvailabilityCallsItems>([])
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false)
  const recaptchaRef = useRef<ReCAPTCHA>(null)
  const [loading, setLoading] = useState(false)
  const location = useLocation()
  const params = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  )

  useEffect(() => {
    const fetchSpecialities = async () => {
      const specialities = await getSpecialities()
      const parsedSpecialities: SpecialitiesItems = specialities.map(
        speciality => {
          return {
            value: speciality.id.toString(),
            label: speciality.name,
          }
        },
      )
      setSpecialities(parsedSpecialities)
    }

    const fetchPreferences = async () => {
      const preferences = await getPreferences()
      const parsedPreferences: PreferencesItems = preferences.map(
        preference => {
          return {
            value: preference.id.toString(),
            label: preference.name,
          }
        },
      )
      setPreferences(parsedPreferences)
    }

    const fetchAvailabityCalls = async () => {
      const availabityCalls = await getAvailabilityCalls()
      const parsedAvailabityCalls: AvailabilityCallsItems = availabityCalls.map(
        availabityCall => {
          return {
            value: availabityCall.id,
            label: availabityCall.name,
          }
        },
      )
      setAvailabityCalls(parsedAvailabityCalls)
    }

    Promise.all([
      fetchSpecialities(),
      fetchPreferences(),
      fetchAvailabityCalls(),
    ])
  }, [])

  const handleSubmit = async (
    payload: Registry,
    form: UseFormReturnType<Registry>,
  ) => {
    setLoading(true)
    const token = await recaptchaRef.current.executeAsync()
    try {
      if (params.get('clinica')) {
        payload.preferenceForAttendance = params.get('clinica')
      }

      await registerProfessional(payload, token)
      setIsSuccessModalOpen(true)
      form.reset()
      recaptchaRef.current.reset()
    } catch (error) {
      toast({
        message: error?.response?.data?.msg || 'Cadastro não pode ser enviado',
        variant: 'warning',
        theme: 'dark',
      })
      recaptchaRef.current.reset()
    }
    setLoading(false)
  }

  return (
    <Layout>
      <RegisterForm
        loading={loading}
        recaptchaRef={recaptchaRef}
        specialities={specialities}
        preferences={preferences}
        availabityCalls={availabityCalls}
        onSubmit={handleSubmit}
        clinicId={params.get('clinica')}
      />

      <SuccessModal
        isOpen={isSuccessModalOpen}
        onClose={() => setIsSuccessModalOpen(false)}
      />
    </Layout>
  )
}

export default Register
